import { Flex, Rte, Text } from "@capioweb/ui-components"
import {
	INNER_MAX_WIDTH,
	READABLE_LINE_MAX_WIDTH,
} from "@capioweb/ui-components/src"
import {
	BooleanProperty,
	StringProperty,
} from "../../@types/EpiFoundationSpa/Property"
import { createMarkup } from "../../utils"

interface BodyBlockRteProps {
	heading?: StringProperty
	body?: StringProperty
	anchorId?: StringProperty
	leftAligned: BooleanProperty
	topMargin?: BooleanProperty
	centeredHeading?: BooleanProperty
}

const CapioBodyBlock: React.FC<BodyBlockRteProps> = (props) => {
	return (
		<Flex
			as="section"
			w={1}
			px={3}
			pb={3}
			mt={props.topMargin?.value ? 3 : 0}
			id={props.anchorId?.value ?? null}
		>
			<Flex maxw={INNER_MAX_WIDTH} w={1} m="0 auto">
				<Flex
					flexDirection="column"
					maxw={READABLE_LINE_MAX_WIDTH}
					my={0}
					mx={props.leftAligned.value ? 0 : "auto"}
				>
					{props.heading?.value && (
						<Text
							variant="headline-2"
							textAlign={props.centeredHeading?.value ? "center" : "left"}
							mb={1.5}
						>
							{props.heading?.value}
						</Text>
					)}
					{props.body?.value && (
						<Rte>
							<div
								dangerouslySetInnerHTML={createMarkup(props.body.value)}
							></div>
						</Rte>
					)}
				</Flex>
			</Flex>
		</Flex>
	)
}

export { CapioBodyBlock }
